import { compose, pure } from '../../../../src/web/utils/react';
import { widget } from '../../../../src/web/components/widgets/decorators';
import { NAME, ID } from './properties';
import Placeholder from './Placeholder';

export default compose(
  pure(),
  widget(
    { name: NAME, deprecated: true, componentId: ID },
    { menu: { items: ['delete'] } },
  ),
)(Placeholder);
